import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule  } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MainRoutingModule } from './main-routing.module';
import { MainComponent } from './main.component';
import { DataModule } from '../data/data.module';
import { ProjectListModule } from '../project/projectList/project-list.module';
import { CreateClientModule } from '../client/create-client.module';
import { CreateObjectDialogModule } from '../createObjectDialog/create-object-dialog.module';
import { ProjectService } from '../project/project.service';
import { AuthenticationService } from '../login/authentication.service';
import { ProjectModule } from '../project/project.module';
import { Constants } from '../model/constants';
import { DeviceDetectorModule} from 'ngx-device-detector';
import { DashboardModule} from '../Dashboard/dashboard.module';
import {GalleryModule} from '../hashtag-gallery/gallery.module';
import {ControlPanelModule} from '../controlPanel/control-panel.module';
import {SharedRefreshService} from '../service/sharedRefreshService';


@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        BrowserModule,
        RouterModule,
        DataModule,
        MainRoutingModule,
        DeviceDetectorModule.forRoot(),
        DashboardModule,
        ProjectModule,
        ProjectListModule,
        CreateClientModule,
        CreateObjectDialogModule,
        ControlPanelModule,
        GalleryModule

    ],
    declarations: [
        MainComponent
 ],
    providers: [ProjectService, AuthenticationService, Constants,SharedRefreshService]
})
export class MainModule {

}
